<template>
  <!-- <div :class="loadClass" v-show="loading">
    <li class="spinner-list" title="pulse loader">
      <div class="v-spinner">
        <h2></h2>
        <div
          class="v-pulse v-pulse1"
          v-bind:style="[spinnerStyle, spinnerDelay1]"
        ></div>
        <div
          class="v-pulse v-pulse2"
          v-bind:style="[spinnerStyle, spinnerDelay2]"
        ></div>
        <div
          class="v-pulse v-pulse3"
          v-bind:style="[spinnerStyle, spinnerDelay3]"
        ></div>
      </div>
    </li>
  </div> -->
  <div :class="loadClass" v-show="loading">
    <div class="spinner-list">
      <div id="flower">
        <img
          :src="`assets/health/images/icn_loading.svg` | bindCDNPath"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PulseLoader",

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#5dc596"
    },
    size: {
      type: String,
      default: "18px"
    },
    margin: {
      type: String,
      default: "2px"
    },
    radius: {
      type: String,
      default: "100%"
    }
  },
  data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: "inline-block",
        animationName: "v-pulseStretchDelay",
        animationDuration: "0.75s",
        animationIterationCount: "infinite",
        animationTimingFunction: "cubic-bezier(.2,.68,.18,1.08)",
        animationFillMode: "both"
      },
      spinnerDelay1: {
        animationDelay: "0.12s"
      },
      spinnerDelay2: {
        animationDelay: "0.24s"
      },
      spinnerDelay3: {
        animationDelay: "0.36s"
      },
      closeClass: "loader-backdrop fade",
      showClass: "loader-backdrop fade show",
      loadClass: "loader-backdrop fade show",
      msg: ""
    };
  },
  methods: {
    setTypes(spinnerStyle) {
      this.spinnerStyle = spinnerStyle;
    },
    setClass(loading, spinnerStyle) {
      const defaultSpinnerStyle = this.spinnerStyle;
      const classStyle = { ...defaultSpinnerStyle, ...spinnerStyle };
      this.spinnerStyle = classStyle;
      this.loading = loading;
    },
    open() {
      this.loading = true;
      this.loadClass = this.showClass;
    },
    close() {
      this.loading = false;
      this.loadClass = this.closeClass;
    }
  }
};
</script>

<style>
/*.v-spinner
{
    margin: 100px auto;
    text-align: center;
}
*/
.spinner-list {
  /*  width: 200px;
	  height: 150px;
	  line-height: 150px;
	  color: white;
	  font-weight: bold;
	  font-size: 3em;
	  text-align: center;*/

  text-align: center;
  display: -webkit-flex;
  display: flex;

  webkit-flex: 0 1 auto;
  flex: 0 1 auto;

  -webkit-flex-flow: row wrap;
  flex-flow: row wrap;
  width: 100%;
  height: 100vh;
  webkit-align-items: center;
  align-items: center;
  webkit-justify-content: center;
  justify-content: center;
}

.loader-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9888;
  background-color: #ffffff;
}

.loader-backdrop li {
  position: fixed;
  top: 40%;
  /* left: 45%; */
  z-index: 9889;
}

.loader-backdrop.fade {
  opacity: 0;
}

.loader-backdrop.show {
  opacity: 0.5;
}

@-webkit-keyframes v-pulseStretchDelay {
  0%,
  80% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-opacity: 1;
    opacity: 1;
  }
  45% {
    -webkit-transform: scale(0.1);
    transform: scale(0.1);
    -webkit-opacity: 0.7;
    opacity: 0.7;
  }
}

@keyframes v-pulseStretchDelay {
  0%,
  80% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-opacity: 1;
    opacity: 1;
  }
  45% {
    -webkit-transform: scale(0.1);
    transform: scale(0.1);
    -webkit-opacity: 0.7;
    opacity: 0.7;
  }
}

@keyframes flowerLoading {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

#flower {
  animation: flowerLoading 1s infinite linear;
  position: relative;
  top: 40px;
}
</style>
